var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSwitchDevice(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.4286 59.4286H11.4286C8.90518 59.4286 6.85718 57.3806 6.85718 54.8571V9.14284C6.85718 6.61941 8.90518 4.57141 11.4286 4.57141H43.4286C45.952 4.57141 48 6.61941 48 9.14284V20.5714H41.1429V13.7143H13.7143V50.2857H41.1429V43.4286H48V54.8571C48 57.3806 45.952 59.4286 43.4286 59.4286ZM52.0315 40.6602C51.015 41.691 49.2773 40.9613 49.2773 39.5035V35.2723H36.3698C34.5885 35.2723 33.1429 33.8063 33.1429 32C33.1429 30.1937 34.5885 28.7276 36.3698 28.7276H49.2773V24.4965C49.2773 23.0387 51.015 22.3089 52.0315 23.3397L60.5715 32L52.0315 40.6602Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitchDevice);
export default __webpack_public_path__ + "static/media/switch-device.21e7344dec89c89a7ed94bf32659d871.svg";
export { ForwardRef as ReactComponent };